import { Action, Reducer } from "redux"
import { AuthUserType, MetricsAPIType } from "../../../Actions/Types"
import { UserAction } from "../../Auth/UserReducer"
import {
    RemoteData,
    getInitialData,
    setPage
} from "../../../Models/Client/RemoteData"
import {
    APIMeasurerMetric,
    APIMetricConstraint,
    getMetricConstraintID
} from "../../../Models/API/APIMetric"
import { FetchState, hasValue } from "../../../Models/Client/FetchState"

export interface MetricsState {
    metricConstraints: RemoteData<
        APIMetricConstraint,
        { name?: string },
        number
    >
    measurerMetrics: { [appID: string]: FetchState<APIMeasurerMetric[]> }
}

interface MetricConstraintStateChangedAction
    extends Action<MetricsAPIType.metricConstraintListFetchStateChanged> {
    meta: {
        page: number
        pageSize: number
        name?: string
    }
    payload: FetchState<{ records: APIMetricConstraint[]; total: number }>
}

interface MeasurerMetricListSetAction
    extends Action<MetricsAPIType.setMeasurerMetricList> {
    meta: { appID: string }
    payload: FetchState<APIMeasurerMetric[]>
}

export type MetricsAction =
    | MetricConstraintStateChangedAction
    | MeasurerMetricListSetAction

const initialState: MetricsState = {
    metricConstraints: getInitialData(),
    measurerMetrics: {}
}

export const MetricsReducer: Reducer<MetricsState, MetricsAction | UserAction> =
    (state = initialState, action): MetricsState => {
        switch (action.type) {
            case MetricsAPIType.metricConstraintListFetchStateChanged:
                return {
                    ...state,
                    metricConstraints: hasValue(action.payload)
                        ? setPage(
                              state.metricConstraints,
                              { name: action.meta.name },
                              action.payload.value.records,
                              getMetricConstraintID,
                              action.meta.page,
                              action.payload.value.total
                          )
                        : state.metricConstraints
                }
            case MetricsAPIType.setMeasurerMetricList:
                return {
                    ...state,
                    measurerMetrics: {
                        ...state.measurerMetrics,
                        [action.meta.appID]: action.payload
                    }
                }
            case AuthUserType.signedOut:
                return initialState
            default:
                return state
        }
    }
